document.addEventListener('bss_b2b:calculate_nt_order_done', () => {
    const target = document.querySelector('.b2b-nt-cart-tax-price');

    if (target) {
        const observer = new MutationObserver(() => {
            const spans = target.querySelectorAll('span');
            if (spans.length >= 2 && spans[1].textContent.includes('Included')) {
                spans[0].textContent = 'zzgl. MwSt.';
                spans[1].textContent = spans[1].textContent.replace(/\s*\(Included\)/i, '');
            }
        });

        observer.observe(target, {
            childList: true,
            subtree: true,
            characterData: true
        });
        const spans = target.querySelectorAll('span');
        if (spans.length >= 2 && spans[1].textContent.includes('Included')) {
            spans[0].textContent = 'zzgl. MwSt.';
            spans[1].textContent = spans[1].textContent.replace(/\s*\(Included\)/i, '');
        }
    }
})